import { useCallback, useContext, useEffect, useState } from "react";
import InnerLayout from "../../../components/layouts/inner-layout";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import LoadingSpinner from "../../../components/helper-components/loading-spinner";
import moment from "moment";
import { DataContext } from "../../../components/layouts/main-layout";

import {
  purchaseInvoiceTableAction,
  purchaseInvoiceViewAction,
  purchaseInvoiceVoidAction,
} from "../../../redux/actions/purchase-action";
import { storeDetailsAction } from "../../../redux/actions/invoices-action";
import errorToast from "../../../components/helper-components/error-toast";
import successToast from "../../../components/helper-components/success-toast";

import {
  formatIndianNumber,
  handlea4Print,
} from "../../../components/helper-components/helper-function";
import DynamicTransactionTable from "../../../components/tables/dynamic-transaction-table";
import SalesPurchaseFilter from "../../../components/sales-section/sales-purchase-filter";
import BadgesComponent from "../../../components/tables/badges-component";
import TransSummaryComp from "../../../components/helper-components/trans-summary-comp";
import {
  ChartColumnIncreasing,
  FileText,
  MoveDownLeft,
  TimerIcon,
} from "lucide-react";

const PurchaseInvoiceTable = () => {
  const [billSummary, setBillSummary] = useState({});

  const [heading, setHeading] = useState([]);
  const [showFilter, setShowFilter] = useState(false);
  const { permissionFn } = useContext(DataContext);
  const dispatch = useDispatch();
  const [expandedRows, setExpandedRows] = useState([]);
  const [orders, setOrders] = useState([]);
  const [dataCount, setDataCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [action, setAction] = useState(false);
  const [itemLoading, setItemLoading] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(null);
  const [invoiceItems, setInvoiceItems] = useState([]);
  const [storeDetails, setStoreDetails] = useState({});
  const [reload, setReload] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState("");
  useEffect(() => {
    dispatch(storeDetailsAction(onSuccessStoreDetails, onErrorStoreDetails));
    const data = localStorage.getItem("ModPermission");
    if (data) {
      const parsed = JSON.parse(data);
      const transferData = parsed.find((obj) => obj?.purchase_invoice_list);
      if (transferData?.purchase_invoice_list) {
        setHeading(transferData.purchase_invoice_list);
      }
    }
  }, []);
  const onSuccessStoreDetails = (data) => {
    setStoreDetails(data?.data);
  };
  const onErrorStoreDetails = () => {};
  const [filterData, setFilterData] = useState({
    sort_by: "",
    sort_order: "",
    // selectColumn: "poit_invoice_number",
    selectColumn: "",
    from: "",
    to: "",
    inputValue: "",
    orderStatus: "",
  });
  useEffect(() => {
    dispatch(
      purchaseInvoiceTableAction(
        {
          pageNumber: currentPage,
          pageSize: pageSize,
          filterData,
        },
        onSuccess,
        onError
      )
    );
  }, [currentPage, pageSize, filterData, reload]);
  const onSuccess = (data) => {
    setError(false);
    setLoading(false);
    setOrders(data?.data?.orderList ?? []);
    setDataCount(data?.data?.totalCount);
    setBillSummary(data?.data?.orderStats);
  };
  const onError = (data) => {
    setError(true);
    setLoading(false);
  };
  const navigate = useNavigate();
  const paginationProps = {
    pageSize: pageSize,
    setPageSize: setPageSize,
    dataCount: dataCount,
    setCurrentPage: setCurrentPage,
    currentPage: currentPage,
  };
  const initialFilter = {
    sort_by: "",
    sort_order: "",
    selectColumn: "poit_invoice_number",
    from: "",
    to: "",
    inputValue: "",
    orderStatus: "",
  };

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        action &&
        currentIndex != null &&
        !event.target.closest(".relative")
      ) {
        setAction(false);
        setCurrentIndex(null);
      }
    };
    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, [action, currentIndex]);

  const tableBodyData = orders?.map((item) => {
    return {
      id: item?.poit_id,
      poit_invoice_number:
        (
          <span className="fw_500 cursor-pointer">
            {item?.poit_invoice_number ?? "--"}
          </span>
        ) ?? "--",
      update_date: moment(item?.update_date).format("MMM D, YYYY"),
      order_status: <BadgesComponent status={item?.poit_order_status} />,
      cmr_name: item?.cmr_name ?? "--",
      poit_total_amount: "₹ " + item?.poit_total_amount,
      itemData: item?.itemData?.length > 0 ? item?.itemData : [],
      is_draft_order: item?.is_draft_order,
      cmr_id: item?.cmr_id ?? "--",
      poit_order_status: item?.poit_order_status ?? "",
    };
  });

  const [heightOfFirstDiv, setHeightOfFirstDiv] = useState(0);
  useEffect(() => {
    const updateHeight = () => {
      const firstDivHeight = document.querySelector(".head-div")?.clientHeight;
      setHeightOfFirstDiv(firstDivHeight);
    };
    updateHeight();
    window.addEventListener("resize", updateHeight);
    return () => {
      window.removeEventListener("resize", updateHeight);
    };
  }, [loading]);
  const filterby = showFilter ? (
    <SalesPurchaseFilter
      filterData={filterData}
      setFilterData={setFilterData}
      setCurrentPage={setCurrentPage}
    />
  ) : null;
  const handleFilterClick = useCallback(() => {
    setShowFilter((prevShowFilter) => !prevShowFilter);
  }, []);

  const totalInvoices = billSummary?.totalInvoices ?? 0;
  const averageInvoiceValue = billSummary?.averageInvoiceValue ?? 0;
  const pendingInvoices = billSummary?.pendingInvoices ?? 0;
  const totalQuantityOrdered = billSummary?.totalQuantityOrdered ?? 0;

  const TransactionSummary = [
    {
      conClass:
        "bg-[var(--trans-stats-con-green-bg)] rounded-[12px] h-[5.3rem] w-[25%] p-3 flex justify-between",
      label: "Total Qty invoiced Units ",
      value: totalQuantityOrdered?.count ?? 0,
      desc: `₹${formatIndianNumber(totalQuantityOrdered?.value || 0)}`,
      descClass:
        "text-[length:var(--trans-stats-con-desc-fs)] font-[var(--trans-stats-con-desc-fw)] text-[var(--trans-stats-con-green-fg)]",
      icon: <MoveDownLeft size={16} color="var(--trans-stats-con-green-fg)" />,
      labelClass:
        "text-[length:var(--trans-stats-con-label-fs)] font-[var(--trans-stats-con-label-fw)] text-[var(--trans-stats-con-label-fg)]",
      valueClass:
        "text-[length:var(--trans-stats-con-value-fs)] font-[var(--trans-stats-con-value-fw)] text-[var(--trans-stats-con-value-fg)] mt-2",
    },
    {
      conClass:
        "bg-[var(--trans-stats-con-orange-bg)] rounded-[12px] h-[5.3rem] w-[25%] p-3 flex justify-between",
      label: "Avg. Invoice Value",
      value: `₹ ${formatIndianNumber(averageInvoiceValue?.value || 0)}`,
      desc: `${averageInvoiceValue?.changePercentage < 0 ? "" : "+"}${
        averageInvoiceValue?.changePercentage
      }% vs last week`,
      descClass:
        "text-[length:var(--trans-stats-con-desc-fs)] font-[var(--trans-stats-con-desc-fw)] text-[var(--trans-stats-con-orange-fg)]",
      icon: (
        <ChartColumnIncreasing
          size={16}
          color="var(--trans-stats-con-orange-fg)"
        />
      ),
      labelClass:
        "text-[length:var(--trans-stats-con-label-fs)] font-[var(--trans-stats-con-label-fw)] text-[var(--trans-stats-con-label-fg)]",
      valueClass:
        "text-[length:var(--trans-stats-con-value-fs)] font-[var(--trans-stats-con-value-fw)] text-[var(--trans-stats-con-value-fg)] mt-2",
    },
    {
      conClass:
        "bg-[var(--trans-stats-con-red-bg)] rounded-[12px] h-[5.3rem] w-[25%] p-3 flex justify-between",
      label: "Pending Invoices",
      value: pendingInvoices?.count || 0,
      desc: `₹${formatIndianNumber(pendingInvoices?.value || 0)} pending`,
      descClass:
        "text-[length:var(--trans-stats-con-desc-fs)] font-[var(--trans-stats-con-desc-fw)] text-[var(--trans-stats-con-red-fg)]",
      icon: <TimerIcon size={16} color="var(--trans-stats-con-red-fg)" />,
      labelClass:
        "text-[length:var(--trans-stats-con-label-fs)] font-[var(--trans-stats-con-label-fw)] text-[var(--trans-stats-con-label-fg)]",
      valueClass:
        "text-[length:var(--trans-stats-con-value-fs)] font-[var(--trans-stats-con-value-fw)] text-[var(--trans-stats-con-value-fg)] mt-2",
    },
    {
      conClass:
        "bg-[var(--trans-stats-con-blue-bg)] rounded-[12px] h-[5.3rem] w-[25%] p-3 flex justify-between",
      label: "Total Purchase Invoices",
      value: totalInvoices?.count ?? 0,
      desc: `${totalInvoices?.changePercentage < 0 ? "" : "+"}${
        totalInvoices?.changePercentage
      }% vs last month`,
      descClass:
        "text-[length:var(--trans-stats-con-desc-fs)] font-[var(--trans-stats-con-desc-fw)] text-[var(--trans-stats-con-blue-fg)]",
      icon: <FileText size={16} color="var(--trans-stats-con-blue-fg)" />,
      labelClass:
        "text-[length:var(--trans-stats-con-label-fs)] font-[var(--trans-stats-con-label-fw)] text-[var(--trans-stats-con-label-fg)]",
      valueClass:
        "text-[length:var(--trans-stats-con-value-fs)] font-[var(--trans-stats-con-value-fw)] text-[var(--trans-stats-con-value-fg)] mt-2",
    },
  ];

  const summaryArray =
    TransactionSummary?.length > 0 ? (
      <div className="px-[24px] pt-[16px] flex gap-5">
        {TransactionSummary?.map((sum) => (
          <TransSummaryComp sum={sum} />
        ))}
      </div>
    ) : (
      <></>
    );

  return (
    <InnerLayout
      permissionFn={permissionFn}
      module="invoice"
      list={true}
      onclkFn={() => {
        navigate(
          `/add-purchase-invoice/${encodeURIComponent(
            JSON.stringify([])
          )}/invoice`
        );
      }}
      title="Purchase Invoice"
    >
      {loading ? (
        <LoadingSpinner />
      ) : error ? (
        <></>
      ) : (
        <>
          <DynamicTransactionTable
            ViewAction={purchaseInvoiceViewAction}
            transaction="Purchase Invoice"
            transaction_type="purchase_invoice"
            setInvoiceItems={setInvoiceItems}
            invoiceItems={invoiceItems}
            options={options}
            orders={orders}
            setOrders={setOrders}
            tableHeading1={tableHeading1}
            is_checkbox_req={true}
            onClickItemFn={(id) => navigate(`/view-purchase-invoice/${id}`)}
            list={true}
            onclkFn={() => {
              navigate(
                `/add-purchase-invoice/${encodeURIComponent(
                  JSON.stringify([])
                )}/invoice?new`
              );
            }}
            cloneFn={(id) => {
              navigate(
                `/add-purchase-invoice/${encodeURIComponent(
                  JSON.stringify([])
                )}/invoice?cloneID=${id}`
              );
            }}
            permissionFn={permissionFn}
            module={"purchase_invoice"}
            path="purchase-invoice"
            reload={reload}
            setReload={setReload}
            loading={loading}
            setLoading={setLoading}
            deleteAction={purchaseInvoiceVoidAction}
            label="Purchase Invoice"
            showFilter={showFilter}
            filterFn={handleFilterClick}
            setFilterData={setFilterData}
            filterData={filterData}
            paginationProps={paginationProps}
            tableHeading={heading}
            tableBodyData={tableBodyData}
            placeholder="Search (/)"
            filterBy={filterby}
            initialFilter={{
              sort_by: "",
              sort_order: "",
              selectColumn: "gort_invoice_number",
              from: "",
              to: "",
              inputValue: "",
              orderStatus: "",
            }}
            handleSelect={(item) => {
              if (item?.value === "purchase_credit_note") {
                navigate(
                  `/add-purchase-credit/${encodeURIComponent(
                    JSON.stringify(invoiceItems)
                  )}/invoice?type=poit`
                );
              } else {
                navigate(
                  `/add-payment-out/${encodeURIComponent(
                    JSON.stringify(invoiceItems)
                  )}/invoice?type=poit`
                );
              }
            }}
            transactionKey="poit"
            actionsPermissions={{
              edit: ["open", "draft"], // Edit allowed for "open" and "draft"
              delete: ["open", "draft"], // Delete allowed only for "open"
              print: ["open", "closed", "draft"], // Print allowed for "open" and "closed"
              send: ["open", "closed", "draft"], // Share allowed for "open" and "closed"
              clone: ["open", "closed", "draft"], // Share allowed for "open" and "closed"
            }}
            summaryArray={summaryArray}
          />
        </>
      )}
    </InnerLayout>
  );
};

export default PurchaseInvoiceTable;

const tableHeading = [
  {
    label: "PURCHASE INVOICE NUMBER",
    value: "poit_invoice_number",
    display: true,
    column: true,
  },
  { label: "DATE", value: "update_date", display: true, column: false },
  {
    label: "ORDER STATUS",
    value: "order_status",
    display: false,
    column: false,
  },
  {
    label: "CUSTOMER NAME",
    value: "cmr_name",
    display: true,
    column: true,
  },
  {
    label: <span className="flex justify-end">AMOUNT</span>,
    value: "poit_total_amount",
    display: true,
    column: false,
    className: "justify-end pe-5",
  },
  { label: "", value: "", column: false },
  // { label: "", value: "", column: false },
];

const tableHeading1 = [
  { label: "PRODUCT NAME", value: "item_name" },
  { label: "GENERIC NAME", value: "item_generic_name" },
  { label: "ITEM CODE", value: "item_code" },
  { label: "UOM", value: "item_uom" },
  { label: "PRICE (₹)", value: "item_unit_price" },
  { label: "QTY", value: "item_quantity" },
  { label: "TOTAL (₹)", value: "item_total_amount" },
];

const options = [
  // { value: "payment_out", label: "Payment out" },
  { value: "purchase_credit_note", label: "Purchase Credit Note" },
];
